export default "__VITE_ASSET__2c3f4e8c__"